import { MenuDivider, SubMenu, MenuItem } from "@szhsin/react-menu";
import { observer } from "mobx-react-lite";
import React from "react";
import { useClickMenu } from "../common/useClickMenu";
import { useDevice } from "../../utils/style/useDevice";
import { concatClassnames, findSelfOrParent } from "../../utils/util";
import { CompletedMenuItem } from "../../business-components/nav/MenuItems/completeMenuItem";

export interface DeepFriedMenuItemProps {
  pItem: CompletedMenuItem;
}
export const DeepFriedMenuItem = observer((props: DeepFriedMenuItemProps) => {
  const { pItem } = props;

  const { isTabletOrMobile } = useDevice();
  const clickMenu = useClickMenu();

  const hasSubItems = pItem.items?.length > 0;
  const Template = pItem.template;
  const isSeparator = !!pItem?.separator;

  const subMenuHasIcon = pItem.items?.some((item) => !!item.icon);

  return (
    <>
      {isSeparator && <MenuDivider />}
      {hasSubItems && !isSeparator && (
        <SubMenu
          aria-label={pItem.label}
          disabled={pItem.disabled}
          direction={!isTabletOrMobile ? "right" : "bottom"}
          label={
            Template ? (
              <Template />
            ) : (
              <div className="subMenu-item-template">
                <div className="icon-label">
                  <i className={concatClassnames([pItem.icon, "pi pi-fw"])} />
                  {pItem.label}
                </div>
                <i className="pi pi-fw pi-angle-right" />
              </div>
            )
          }
          className={concatClassnames([
            "cvp-react-menu__item",
            pItem.className,
          ])}
          overflow="auto"
          itemProps={{
            onClick: (evt) => {
              if (clickMenu) {
                toggleSubMenuOnClick(evt);
              }
            },
          }}
        >
          {pItem.items.map((subItem, subIndex) => {
            if (subItem.separator) {
              return (
                <MenuDivider
                  key={subIndex}
                  className={concatClassnames([subItem.className])}
                />
              );
            }

            return (
              <MenuItem
                key={subIndex}
                onClick={(evt) => {
                  subItem.command?.(evt.syntheticEvent);
                }}
                href={subItem.url}
                className={subItem.className}
                disabled={subItem.disabled}
              >
                {!!subMenuHasIcon && (
                  <i
                    className={concatClassnames([subItem.icon, "pi pi-fw"])}
                  ></i>
                )}
                {subItem.label}
              </MenuItem>
            );
          })}
        </SubMenu>
      )}
      {!hasSubItems && !isSeparator && (
        <MenuItem
          onClick={(evt) => {
            pItem.command?.(evt.syntheticEvent);
          }}
          href={pItem.url}
          target={pItem.target}
          className={concatClassnames([
            "cvp-react-menu__item",
            pItem.className,
            pItem.isSelected ? "active" : "",
          ])}
          disabled={pItem.disabled}
        >
          {Template ? (
            <Template />
          ) : (
            <>
              {!!pItem.icon && (
                <i className={concatClassnames([pItem.icon, "pi pi-fw"])} />
              )}
              {pItem.label}
            </>
          )}
        </MenuItem>
      )}
    </>
  );
});

// hack that will break some day
const toggleSubMenuOnClick: React.MouseEventHandler<HTMLElement> = (evt) => {
  const node: HTMLUListElement = findSelfOrParent(evt.target, (n) =>
    n.className.includes("cvp-react-menu__item")
  );

  const menuitem: HTMLUListElement = node?.querySelector?.("ul");

  if (!menuitem) return;

  if (menuitem.classList.contains("szh-menu--state-open")) {
    menuitem.classList.remove("szh-menu--state-open");
    menuitem.classList.add("hidden");
  } else {
    menuitem.classList.add("szh-menu--state-open");
    menuitem.classList.remove("hidden");
  }
};
